// Tapping a gap asks about that stretch of time.
//
// The period is the sheet's title rather than a line inside the form, so the
// question never reads as one job spanning the whole stretch — a driver may
// have had several, and answering here commits them to nothing.

import { ChoiceRow } from './ChoiceRow'

export interface QuestionStepProps {
  onAnswer: (employed: boolean) => void
}

export const QuestionStep = ({ onAnswer }: QuestionStepProps) => (
  <div className="flex flex-col gap-2 rounded-[13px] bg-white p-2.5">
    <ChoiceRow
      label="I was employed"
      emphasis
      onSelect={() => onAnswer(true)}
    />
    <ChoiceRow label="I was not employed" onSelect={() => onAnswer(false)} />
  </div>
)
